import { HARDWARE_CHECKLIST,TS_LIST,CHALLAN_ITEMS } from "./type";

const initalState = {
  hardwareInstallData: {},
  tsList: {},
  challanItems: {}
};

const hardwareInstallReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case HARDWARE_CHECKLIST:
      return {
        ...state,
        hardwareInstallData: payload,
      };
    case TS_LIST:
      return {
        ...state,
        tsList: payload
      }
    case CHALLAN_ITEMS:
      return {
        ...state,
        challanItems: payload
      }
    default:
      return {
        ...state,
      };
  }
};

export default hardwareInstallReducer;
